import lf from 'lovefield'

export function const_usagesengins_const_usagesengins (schemaBuilder) {
  schemaBuilder.createTable('const_usagesengins_const_usagesengins')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('const_usagesengins_1_id', lf.Type.INTEGER)
      .addColumn('const_usagesengins_2_id', lf.Type.INTEGER)
}

/*
CREATE TABLE `const-usagesengins` (
  `const-sols_code` varchar(4) NOT NULL,
  `const-humidites_code` varchar(10) NOT NULL,
  `const-famillesengins_const-options_const-phases_id` int(11) NOT NULL,
  `usage` varchar(2) NOT NULL
) ENGINE=InnoDB DEFAULT CHARSET=utf8;
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/constUsagesenginsconstUsagesengins.schema.js